var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-10 mb-16"},[_c('v-col',{staticClass:"text-center"},[_c('div',{staticClass:"text-h4 font-weight-bold"},[_vm._v("Loading...")]),_vm._v(" "),_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"blue","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }